(function() {
var t = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (error_message, link_href, link_text, subtitle, title) {
var link_onclick = (link_onclick ? link_onclick : "")
buf.push("<div class=\"container app-error-container\"><div class=\"content\"><div class=\"page-header\">");
if ( typeof title !== 'undefined' && title)
{
buf.push("<h1>" + (((jade_interp = title) == null ? '' : jade_interp)) + "</h1>");
}
if ( typeof subtitle !== 'undefined' && subtitle)
{
buf.push("<h2>" + (((jade_interp = subtitle) == null ? '' : jade_interp)) + "</h2>");
}
buf.push("</div><div id=\"content\">");
if ( typeof error_message !== 'undefined' && error_message)
{
buf.push("<p>" + (((jade_interp = error_message) == null ? '' : jade_interp)) + "</p>");
}
if ( typeof link_onclick !== 'undefined' && link_onclick)
{
buf.push("<a" + (jade.attr("href", "" + (link_href) + "", true, false)) + (jade.attr("onclick", "" + (link_onclick) + "", true, false)) + ">" + (jade.escape((jade_interp = link_text) == null ? '' : jade_interp)) + "</a>");
}
else
{
buf.push("<a" + (jade.attr("href", "" + (link_href) + "", true, false)) + ">" + (jade.escape((jade_interp = link_text) == null ? '' : jade_interp)) + "</a>");
}
buf.push("</div></div><footer><img src=\"//static.hubspot.com/final/img/content/sprocket/sprocket-100.png\" style=\"opacity: 0.45; height: 60px; margin-top: -10px;\"/></footer></div>");}.call(this,"error_message" in locals_for_with?locals_for_with.error_message:typeof error_message!=="undefined"?error_message:undefined,"link_href" in locals_for_with?locals_for_with.link_href:typeof link_href!=="undefined"?link_href:undefined,"link_text" in locals_for_with?locals_for_with.link_text:typeof link_text!=="undefined"?link_text:undefined,"subtitle" in locals_for_with?locals_for_with.subtitle:typeof subtitle!=="undefined"?subtitle:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return buf.join("");
};
this.jade.templates || (this.jade.templates = {});
this.jade.templates['error'] = t;

if (typeof hubspot === 'object' && hubspot.define) {
hubspot.updateDependencies('jade.templates.error');
}
return t;
}).call(this);

